import React from 'react';

import CodeVerification from './CodeVerification';

import { useFormContext } from './FormContext';

import { generateMaskedEmail } from './../../../../Helpers/contactInformationMasker';

const EmailVerification = () => {
  const { inputs } = useFormContext();

  async function handleCodeVerification(code) {
    // OTP is bypassed for now — the code "0000" always succeeds.
    if (code !== '0000') {
      return { message: 'Entered OTP is incorrect', shouldDisplayError: true };
    }
    return null;
  }

  return (
    <CodeVerification
      title='Verify Email'
      handleCodeVerification={handleCodeVerification}
      description={`Code is sent to ${generateMaskedEmail(inputs.email)}`}
      helperText="*Check your spam folder as well, if you don't see it in your inbox."
    />
  );
};

export default EmailVerification;
